// Training Mode (ipa-training-mode)
// Client-side persistence for the header 🎓 toggle. Training mode gates the
// pre-send prompt coach and the new-conversation nudge banner. It does NOT
// gate the context-aware suggestion chips — see constants/contextualSuggestions.ts.
const TRAINING_MODE_STORAGE_KEY = 'ai_chat_training_mode';
export function loadTrainingModeEnabled() {
    try {
        const stored = window.localStorage.getItem(TRAINING_MODE_STORAGE_KEY);
        // Default: OFF so admin enablement does not immediately opt users into coaching.
        return stored === null ? false : stored === 'true';
    }
    catch (_a) {
        return false;
    }
}
export function saveTrainingModeEnabled(enabled) {
    try {
        window.localStorage.setItem(TRAINING_MODE_STORAGE_KEY, String(enabled));
    }
    catch (_a) {
        // localStorage unavailable (private mode) — toggle just won't persist
    }
}
// First-enable Coach welcome "seen" state (ipa-training-mode).
// Server is the source of truth (surfaced via the AI token response and the
// server-rendered mount prop, so it follows the user across devices/surfaces).
// This localStorage flag is only an optimistic fast-path: once the user
// dismisses the welcome we hide it immediately for the rest of the session even
// if the server acknowledgement write is slow or fails.
const COACH_WELCOME_SEEN_STORAGE_KEY = 'ai_chat_coach_welcome_seen';
export function loadCoachWelcomeSeen() {
    try {
        return window.localStorage.getItem(COACH_WELCOME_SEEN_STORAGE_KEY) === 'true';
    }
    catch (_a) {
        return false;
    }
}
export function saveCoachWelcomeSeen(seen) {
    try {
        window.localStorage.setItem(COACH_WELCOME_SEEN_STORAGE_KEY, String(seen));
    }
    catch (_a) {
        // localStorage unavailable (private mode) — server flag still authoritative
    }
}
